const state = {
    itens: []
};

export default state;